import React from 'react'
import { cn } from '@/lib/utils'
import LoadingAnimate from '@/components/loading-animate'

interface IFullScreenLoader extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  iconClassName?: string
}

export default function FullScreenLoader(props: IFullScreenLoader) {
  return (
    <div
      className={cn(
        'flex h-screen min-w-full items-center justify-center',
        props.className
      )}
    >
      <LoadingAnimate iconClassName={props.iconClassName} title={props.title} />
    </div>
  )
}
